"use client";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { REQUEST_PARAMS } from "@/constants";
import { UI } from "@/constants/ui-strings";
import { useSetQuery } from "@/hooks";
import { XIcon } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { memo } from "react";

export const ResetFilters = memo(() => {
  const { setQuery, isPending } = useSetQuery();
  const searchParams = useSearchParams();
  if (
    !searchParams.get(REQUEST_PARAMS.date_from) &&
    !searchParams.get(REQUEST_PARAMS.date_to) &&
    !searchParams.get(REQUEST_PARAMS.size) &&
    !searchParams.get(REQUEST_PARAMS.user_id) &&
    !searchParams.get(REQUEST_PARAMS.product_id)
  )
    return null;

  const handleReset = () => {
    setQuery({
      date_from: undefined,
      date_to: undefined,
      size: undefined,
      user_id: undefined,
      product_id: undefined,
    });
  };

  return (
    <Button
      onClick={handleReset}
      size="sm"
      variant={"outline"}
      disabled={isPending}
    >
      <span className="hidden md:block">{UI.buttons.reset}</span>
      {isPending ? <Spinner /> : <XIcon />}
    </Button>
  );
});

ResetFilters.displayName = "ResetFilters";
